export default "__VITE_ASSET__Cfl1elTB__"